// extracted by mini-css-extract-plugin
export default {"pageTitle":"page-title_pageTitle__aDNpz","title":"page-title_title__XxpDy","breadcrumbs":"page-title_breadcrumbs__jInGf"};